import { render, staticRenderFns } from "./ShopType.vue?vue&type=template&id=52fe4cb6&scoped=true&"
import script from "./ShopType.vue?vue&type=script&lang=js&"
export * from "./ShopType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe4cb6",
  null
  
)

component.options.__file = "ShopType.vue"
export default component.exports